webpackJsonp([61233764174865],{

/***/ 736:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Since it has been unclear in the past, I will attempt to clarify what it\nmeans to steal equipment.  Stealing equipment is illegal and will be punished.\nEquipment stealing from a mob is when player A kills a mob with some equipment\nand player B takes it without player A's permission. Equipment stealing from a\nplayer is more complex.  When a whitey dies to a darkie (or mob in PK), the\ndarkie has the option of taking all or none of the equipment. If the darkie\nleaves a corpse full of equipment, whiteys are not welcome to take it without\nthe dead whitey's consent.   On the dark side it works the same way.  If a\ndarkie dies to a whitey, the whitey can leave the equipment or not.  Other\ndarkies may not take the equipment without the dead darkie's permission.</p>\n<p>Convoluted, I know.  Questions, mudmail me.</p>","frontmatter":{"title":"News 1523","date":"October 09, 2017","author":"Azriya","desc":"Equipment Stealing"}}},"pathContext":{"path":"/news/1523"}}

/***/ })

});


// WEBPACK FOOTER //
// path---news-1523-c5305253f8c5c4d61c16.js